/**
 * Converts a date string (YYYY-MM-DD) into "D Month, YYYY" format.
 * Example: "2025-04-07" → "7 April, 2025"
 * 
 * @param {string} dateStr - The date string in YYYY-MM-DD format.
 * @returns {string} - Formatted date string.
 */
export function formatDate(dateStr) {
  const date = new Date(dateStr);

  const options = {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  };

  // @ts-ignore
  const formatted = date.toLocaleDateString('en-GB', options);

  const [day, month, year] = formatted.split(' ');
  return `${day} ${month}, ${year}`;
}